import React, {
  useEffect,
  useState
} from 'react';

import { get } from '../utils/api';

// OPEN PRODUCTION TASK WORKFLOW WARNING
export default function OpenProductionTasksWarning({
  jobOrderId,
  jobOrderStatus,
  compact = false
}) {
  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState('');

  const [tasks, setTasks] =
    useState([]);

  useEffect(() => {
    let active = true;

    if (!jobOrderId) {
      setTasks([]);
      setError('');
      setLoading(false);

      return () => {
        active = false;
      };
    }

    setLoading(true);
    setError('');

    get(
      '/production-counts/job-order/' +
      jobOrderId +
      '/open-production-tasks'
    )
      .then(result => {
        if (!active) return;

        setTasks(
          result?.open_production_tasks ||
          []
        );

        setLoading(false);
      })
      .catch(requestError => {
        if (!active) return;

        setTasks([]);

        setError(
          requestError?.message ||
          'Open Production Tasks could not be checked.'
        );

        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [
    jobOrderId,
    jobOrderStatus
  ]);

  if (!jobOrderId) return null;

  if (loading) {
    return (
      <div style={{
        margin:'12px 0',
        padding:'10px 12px',
        borderRadius:8,
        background:'#F2EFE7',
        color:'#6B625C',
        fontSize:12
      }}>
        Checking open Production Tasks…
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        margin:'12px 0',
        padding:'10px 12px',
        borderRadius:8,
        border:'1px solid #D97066',
        background:'#FDEAEA',
        color:'#8F2E24',
        fontSize:12
      }}>
        <strong>
          Production Task check unavailable.
        </strong>
        {' '}
        {error}
      </div>
    );
  }

  if (tasks.length === 0) {
    if (compact) return null;

    return (
      <div style={{
        margin:'12px 0',
        padding:'10px 12px',
        borderRadius:8,
        border:'1px solid #B8CEAE',
        background:'#E8F5EB',
        color:'#2E6B3A',
        fontSize:12
      }}>
        ✓ No open Production Tasks are
        blocking this Job Order.
      </div>
    );
  }

  return (
    <div style={{
      margin:'12px 0',
      padding:14,
      borderRadius:10,
      border:'2px solid #A8893D',
      background:'#FFF3DC',
      color:'#3B2A21'
    }}>
      <div style={{
        fontSize:13,
        fontWeight:700,
        color:'#8B5E0A',
        marginBottom:6
      }}>
        ⚠ {tasks.length} Open Production {
          tasks.length === 1
            ? 'Task'
            : 'Tasks'
        }
      </div>

      <div style={{
        fontSize:12,
        lineHeight:1.5,
        marginBottom:10
      }}>
        This Job Order cannot advance through
        QC, finished-goods release or dispatch
        until every Production Task is completed
        and verified.
      </div>

      <div style={{
        display:'grid',
        gap:8
      }}>
        {tasks.map(task => (
          <div
            key={task.id}
            style={{
              padding:'9px 10px',
              borderRadius:8,
              background:'rgba(255,255,255,.65)',
              border:
                '1px solid rgba(168,137,61,.35)'
            }}
          >
            <div style={{
              fontSize:12,
              fontWeight:700
            }}>
              {task.title}
            </div>

            <div style={{
              fontSize:11,
              color:'#6B625C',
              marginTop:3
            }}>
              {task.category || 'Production'}
              {' · '}
              {String(
                task.status || 'pending'
              ).replace(/_/g, ' ')}
              {' · '}
              {task.assigned_to_name ||
                'No assignee'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
